import React from 'react';
import './Footer.css'; // Importera en CSS-fil för Footer-styling
import { FaThreads, FaLinkedinIn, FaInstagram,  FaSquareFacebook } from "react-icons/fa6";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-columns">
        <div className="footer-column footer-links">
          <p>&copy; 2024 Codeforged. All rights reserved.</p>
          <a href="https://codeforged.se" target="_blank" rel="noopener noreferrer">CodeForged Tech</a>
          <span>|</span>
          <a href="https://codeforged.se/about" target="_blank" rel="noopener noreferrer">Om CodeForged</a>
        
         
        </div>
        <div className="footer-column social-icons">
          <a href="https://www.facebook.com/codeforgedswe" target="_blank" rel="noopener noreferrer">
          <FaSquareFacebook />
          </a>
          <a href="https://www.instagram.com/codeforged/" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
          </a>
          <a href="https://www.threads.net/@codeforged" target="_blank" rel="noopener noreferrer">
          <FaThreads /> {/* Använd en passande ikon för Threads */}
          </a>
          <a href="https://linkedin.com/company/codeforged" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn /> {/* Använd en passande ikon för Threads */}
          </a>
          <p/>0736550614
          <br/>info(a)codeforged.se
        </div>
        <div className="footer-column contact-info">
      Christer Holm<p/>Edskevägen 3B
          <br/>813 30 Hofors
          
        </div>
      </div>
    </footer>
  );
}

export default Footer;

